module.exports = {
      id: "icon-copy-usage",
      viewBox: "0 0 19.657 19.657",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }